import useStorage from "./useStorage";

export default function useIdMultiPrelievo() {
    const [
        idMacroPrelievo,
        setIdMacroPrelievo,
        resetIdMacroPrelievo
    ] = useStorage({key: 'id_multiprelievo'});

    return [idMacroPrelievo, setIdMacroPrelievo, resetIdMacroPrelievo];
}